import React, { useEffect, useState } from "react";
import {
  downloadCircle,
  downloadDown,
  downloadUp,
  listIcon,
} from "../../../images";
import { RunnerUpHeader, StatusCard} from "../../../ui";
import TableWork from "../../../ui/datatable/DataTable";
import Button from "../../../library/components/Button";
import { Link } from "react-router-dom";
import {
  useGetEpbCountQuery,
  useGetEpbdownloadQuery,
} from "../../../services/finalizeGenerateViewTransmitService";
import { ALERT_TYPE_SUCCESS, VIEW } from "../../../constants/constants";
import "../index.css";
import LeftMenu from "../../AnalyticsModule/Left";
import moment from "moment";

import { useSendSmsToRecordMutation } from '../../../services/sendSmsService'
import { useDispatch } from "react-redux";
import { createAlert } from "../../../features/alert/alerts";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const columns = [
  {
    Header: "S.No",
    accessor: "S_No",
  },
  {
    Header: "Unit ID",
    accessor: "Unit_ID",
  },
  {
    Header: "Name",
    accessor: "Name",
  },
  {
    Header: "Mobile No.",
    accessor: "Mobile_No",
  },
  {
    Header:  "Email",
    accessor: "Email",
  },
  {
    Header:   "e-PB Pending",
    accessor: "e_PB_Pending",
  },
  {
    Header:   "State",
    accessor: "State",
  },
  {
    Header:   "End-Date & Time",
    accessor: "End_Date_Time",
  },
  {
    Header: "Action",
    accessor: "Action",
  },
 
];
const EpbDownloadStatusByRecordOfficer = () => {
  const epbDataRequest = [];
  const { data } = useGetEpbCountQuery();
  const [skip, setSkip] = useState(true);
  const dispatch=useDispatch()
  const { data: epbDownloadData } = useGetEpbdownloadQuery( "",{ skip });
  var endDate=moment(epbDownloadData?.payload?.endDate).format(
    'DD-MMMM-YYYY HH:mm:ss A'
  );

  
  const [sendSmsToRecord ,datap] = useSendSmsToRecordMutation()

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };

  useEffect(()=>{
    if(datap.isSuccess){
      onSuccess(" Sms Sent ")
    }
  },[datap.isSuccess])
  
  epbDownloadData?.payload?.map((item, i) => {
    epbDataRequest.push({
      "S_No": i + 1,
      "Unit_ID": item.userId,
      "Name": item.userName,
      "Mobile_No": item.userMobile,
      "Email": item.userEmail,
      "e_PB_Pending": item.epbPending,
      "State": item.stateName,
      "End_Date_Time":moment(item.endDate).format(
        'DD-MMMM-YYYY HH:mm:ss A'
      ),
      "Action": <Button value="Send Sms" btnClass="btn-class" 
       onClick={() => {
        sendSmsToRecord({
          userId: item.userId,
          stateCd: item.stateCd,
          endDate: moment(item.endDate).format('YYYY-MM-DD HH:mm:ss'),
        })
          .unwrap()
          .then((res) => {
            console.log(res);
          })
          .catch((err) => console.log(err))
      }} />
    });
  });


  const onFetch = () => {
    setSkip(false);
  };
  

  return (
     <div className="pin-download container ">
      <RunnerUpHeaderNew title={"e-PB PIN Download Status"} />
      <div className="row  record_statusCard">
       <div className="col-md-3">
       <StatusCard
          title={"Uploaded e-PB PIN"}
          count={data?.payload?.uploadedEpbPinCount}
          icon={downloadUp}
          bgColor={"#FF87CA"}
        />
       </div>
       <div className="col-md-3">
       <StatusCard
          title={"Downloaded e-PB PIN"}
          count={data?.payload?.downloadedEpbPinCount}
          icon={downloadDown}
          bgColor={"#B983FF"}
        />
       </div>
       <div className="col-md-3">
       <StatusCard
          title={"Pending e-PB PIN"}
          count={data?.payload?.pendingEpbPinCount}
          icon={downloadCircle}
          bgColor={"#EF4B4B"}
        />
       </div>
       
        <Link to="/record/epb-pin-download" className="button">
          {VIEW}
        </Link>
      </div>
     <RunnerUpHeaderNew title={"e-PB Download Status"} />
      <div className="row record_statusCard">
      <div className="col-md-3">
        <StatusCard
          title={"Total Unit"}
          count={data?.payload?.totalUnitCount}
          icon={listIcon}
          bgColor={"#BFB051"}
        />
        </div>
         <div className="col-md-3">
        <StatusCard
          title={"Uploaded e-PB"}
          count={data?.payload?.uploadedEpbCount}
          icon={downloadUp}
          bgColor={"#5AA469"}
        />
        </div>
        <div className="col-md-3">
        <StatusCard
          title={"Downloaded e-PB"}
          count={data?.payload?.downloadedEpbCount}
          icon={downloadDown}
          bgColor={"#763857"}
        />
        </div>
        <div className="col-md-3">
        <StatusCard
          title={"Pending e-PB "}
          count={data?.payload?.pendingEpbCount}
          icon={downloadCircle}
          bgColor={"#6155A6"}
        />
        </div>
        <Link to="" className="button" onClick={onFetch}>
          {VIEW}
        </Link>
      </div>
      {!skip && ( 
        <TableWork
            placeholder="Search"
            globalsearch={true}
            selectall={true}
            columns={columns}
            emptyMessage="No Record Found"
            data={epbDataRequest?.length === 0 ? [] : epbDataRequest}
            size={10}
            tableClassNameCheck="contenttable-eroll"
            pagination
            records
            gotopage
            rows
          />
      )}
    </div>
  );
};

export default EpbDownloadStatusByRecordOfficer;
